import React, { Component } from 'react';
// import '../../App.css';
import { connect } from 'react-redux';
import { BrowserRouter as Router,Route,Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import LevelList from './editTiers/levelList.js';
import Footer from './Footer.js';
import TopNav from '../includes/TopNav';
import {Helmet} from 'react-helmet';
import { resetPassword } from '../../actions/user.js';

class ForgotPassword extends Component{

    constructor(props) {
        super(props);
        this.state = {'resetEmail': ''};
    }
    handleEmailChange(e) {
        this.setState({resetEmail: e.target.value});
    }
    sendResetEmail(e) {
        resetPassword(this.state.resetEmail);
    }
    render() {
        return (
            <div>
                <Helmet>
                    <title>Password Reset | Edit My Paper</title>
                    <meta name="description" content="It is essential that you Accept or Reject all of your editor's changes and remove his/her comments prior to submitting your document."></meta>
                    <meta name="keywords" content="Edit,My,Paper,Editing,Examples,University,College,Students"></meta>
                </Helmet>
                <TopNav />
                <section className="steps top_section">
                    <div id="login-wrapper">
                        <div id="login-form" className="col-md-offset-3 col-md-6 nofloat">
                            <h2>Forgot Your Password?</h2>
                            <p>Please enter the email associated with your account:</p>
                            <p><input name="email" type="text" value={this.state.resetEmail} onChange={this.handleEmailChange.bind(this)}/></p>
                            <button type="submit" className="btn btn-default blue-button" onClick={this.sendResetEmail.bind(this)}> Submit </button>
                        </div>
                    </div>
                </section>
                <Footer></Footer>
            </div>
        )
    }
}
export default connect(
  )(ForgotPassword);
  


// WEBPACK FOOTER //
// ./src/components/pages/ForgotPassword.js